// extracted by mini-css-extract-plugin
export default {"transition":"Ap3e1Uwi","slide":"bge97QSX","standaloneWrapper":"FJ_ftDtd","settingsWrapper":"pIyIzOcX"};